<template>
  <div class="wrapper msc-landing-page">
    <section class="msc-landing-hero" aria-label="Welcome">
      <div
        class="msc-landing-hero__media"
        role="img"
        aria-label="Two smiling yellow plush faces on a bench"
        style="background-image: url('/img/smiles.jpeg')"
      ></div>
      <div class="msc-landing-hero__scrim" aria-hidden="true"></div>

      <div class="msc-landing-hero__content">
        <p class="msc-landing-hero__brand">mySchool.cafe</p>
        <h1 class="msc-landing-hero__title">
          Where smiles happen, one meal at a time
        </h1>
        <p class="msc-landing-hero__lead">
          School meal ordering for parents — simple, reliable, and familiar.
        </p>
        <div class="msc-landing-hero__actions">
          <router-link
            v-if="!$root.isUserAuthenticated()"
            class="btn btn-primary btn-round msc-landing-hero__btn msc-landing-hero__btn--primary"
            to="/login"
          >
            Parent Login
          </router-link>
          <router-link
            v-if="!$root.isUserAuthenticated()"
            class="btn btn-success btn-round msc-landing-hero__btn msc-landing-hero__btn--success"
            to="/signup"
          >
            Register For Access
          </router-link>
          <router-link
            v-else
            class="btn btn-primary btn-round msc-landing-hero__btn msc-landing-hero__btn--primary"
            to="/app/main"
          >
            Go to My Account
          </router-link>
        </div>
      </div>
    </section>

    <section class="msc-landing-strip">
      <div class="container">
        <h2 class="msc-landing-strip__title">Lunch, without the scramble</h2>
        <p class="msc-landing-strip__text">
          View menus, place orders, and manage payments in one place — so cafeteria time stays easy for families and schools.
        </p>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'presentation',
    bodyClass: 'msc-landing-page',
  }
</script>
